interface RuleType {
  required?: boolean;
  message?: string;
  pattern?: RegExp;
  max?: number;
  min?: number;
}

const requiredField: RuleType = {
  required: true,
  message: 'Required'
};

export const getRules = (field: string): Array<RuleType> | undefined => {
  switch (field) {
    case 'listenAddress':
    case 'lastUsedAddress': {
      return [
        requiredField,
        { max: 4, message: 'Max length is 4' },
        { pattern: /^[0-9a-fA-F]+$/, message: 'Only hex chars' }
      ];
    }
    case 'min':
    case 'max':
    case 'bit':
      return [
        {
          pattern: /^([-]?[1-9]\d*|0)$/,
          message: 'Int numbers'
        }
      ];
    case 'factor':
      return [
        {
          pattern: /^[-]?([1-9]\d*([.][0-9]+)?|0([.][0-9]+)?)$/,
          message: 'Float numbers'
        }
      ];
    case 'dataType':
      return [
        requiredField,
        { max: 3, message: 'Max 3 chars' },
        {
          pattern: /^[A-Z]+$/,
          message: 'Uppercase letters'
        }
      ];
    case 'parameter':
      return [requiredField, { max: 16, message: 'Max 16 chars' }];
    case 'units':
      return [{ max: 10, message: 'Max 10 chars' }];
    case 'responsible':
      return [{ max: 12, message: 'Max 12 chars' }];
    case 'type':
      return [{ max: 6, message: 'Max 6 chars' }];
    case 'saDescription':
    case 'ttDescription':
    case 'description':
      return [{ max: 255, message: 'Max 255 chars' }];
    case 'comment':
      return [{ max: 510, message: 'Max 510 chars' }];
    case 'name':
      //tab name
      return [
        requiredField,
        { max: 50, message: 'Max 50 chars' },
        {
          pattern: /^[a-zA-Z]+([a-zA-Z0-9\s_.|]+)?$/,
          message: 'Name cannot start with a space and spec.symbol, it can contain A-Z, a-z, 0-9, space, _, ., |'
        }
      ];
    //change password
    case 'password':
    case 'passwordConfirmation':
      return [requiredField, { min: 8, message: 'Min 8 symbols' }];
  }
};
